import React from 'react';
import { Form, Row, Col } from "react-bootstrap";
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { makeStyles } from "@material-ui/core/styles";
import CheckCircleWhite from '../../../../../icons/check-circle-white.svg';
import SvgIcon from '@material-ui/core/SvgIcon';


function FancyButton(props) {

    const useStyles = makeStyles(() => ({
        styledButton: {
            height: '4rem',
            boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
            textTransform: 'none',
        },
        styledButtonError: {
            border: '1px solid red !important',
        },
        styledButtonInactive: {
            border: '1px solid #ffffff',
            borderWidth: '2px',
        },
        styledIcon: {
        },
        styledLabel: {
            marginLeft: 5
        },
        styledCheck: {
        },
        whiteBackground: {
            backgroundColor: "white",
        },
    }));

    const classes = useStyles();

    const buttonClasses = `${classes.styledButton} ${(props.active ? classes.styledButtonActive : classes.styledButtonInactive)} ${(props.error ? classes.styledButtonError : '')} ${props.isWhiteBackground ? classes.whiteBackground : ''}`;

    const blankIcon = props.isBlankIcon ? <SvgIcon component={CheckCircleWhite} /> : <CheckCircleIcon htmlColor='#bbb' />;

    return (
        <Button id="radio-input" className={buttonClasses} variant="outlined" color="primary" fullWidth onClick={props.onClick} aria-describedby="radio-input" aria-invalid="true">
            {props.icon && <div className={`${classes.styledIcon} mr-2`}>{props.icon}</div>}
            <div className={classes.styledCheck}> {props.active ? <CheckCircleIcon color="primary" /> : blankIcon} </div>
            <div className={classes.styledLabel}>{props.label}</div>
        </Button>
    )
}

export default function StyledRadioInput(props) {

    const useStyles = makeStyles(() => ({
        label: {
            color: 'rgba(0, 0, 0, 0.54)',
            padding: '0',
            fontSize: '1rem',
            fontFamily: '"museo-sans", "Helvetica", "Arial", sans-serif',
            fontWeight: '400',
            lineHeight: '1',
        }
    }));

    const classes = useStyles();
    return (
        <div>
            {props.label && <legend className={classes.label}>{props.label}</legend>}
            <Row className='radio-input sm-gutter'>
                {props.options.map((data, i) => {
                    return (
                        <Col xs={6} key={i}>
                            <Form.Group>
                                <FancyButton
                                    active={props.value === data.value}
                                    icon={data.icon}
                                    label={data.label}
                                    onClick={() => props.onChange(data.value)}
                                    error={!!props.errors}
                                    isBlankIcon={props.isBlankIcon}
                                    isWhiteBackground={props.isWhiteBackground}
                                />
                            </Form.Group>
                        </Col>
                    )
                })}


                {props.errors && <span className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error d-block">{props.errors.message}</span>}
            </Row>
        </div>
    )
}

StyledRadioInput.propTypes = {
    onChange: PropTypes.func.isRequired,
    errors: PropTypes.object,
    value: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        icon: PropTypes.object,
    })),
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Aflac/Helpers/Input/StyledRadio.js